import type { LucideIcon } from 'lucide-react';
import {
  Check, X, Pencil, Trash2, ChevronRight, Search, Users, Workflow, Clipboard, Eye,
  AlertTriangle, AlertCircle, Hand, Hourglass, Lock, Lightbulb, MessageCircle,
  Play, ArrowUp, ArrowLeft, ArrowRight, FileText, Zap, Circle, Plus, RefreshCw,
  EyeOff, Settings, LayoutGrid, LogOut, Sparkles, Bug, ShieldCheck, TerminalSquare,
  Sun, Moon, Send, GitBranch, Cpu, Download, ChevronDown, Layers, Rocket,
} from 'lucide-react';

interface IconProps {
  size?: number;
  className?: string;
}

const ICONS: Record<string, LucideIcon> = {
  check: Check,
  x: X,
  edit: Pencil,
  trash: Trash2,
  'chevron-right': ChevronRight,
  search: Search,
  users: Users,
  robot: Workflow,
  clipboard: Clipboard,
  eye: Eye,
  'alert-triangle': AlertTriangle,
  'alert-circle': AlertCircle,
  wave: Hand,
  hourglass: Hourglass,
  lock: Lock,
  lightbulb: Lightbulb,
  message: MessageCircle,
  play: Play,
  'arrow-up': ArrowUp,
  'arrow-left': ArrowLeft,
  'arrow-right': ArrowRight,
  document: FileText,
  zap: Zap,
  record: Circle,
  plus: Plus,
  refresh: RefreshCw,
  eyeoff: EyeOff,
  gear: Settings,
  grid: LayoutGrid,
  'log-out': LogOut,
  sparkle: Sparkles,
  bug: Bug,
  'shield-check': ShieldCheck,
  terminal: TerminalSquare,
  sun: Sun,
  moon: Moon,
  send: Send,
  git: GitBranch,
  cpu: Cpu,
  download: Download,
  'chevron-down': ChevronDown,
  layers: Layers,
  rocket: Rocket,
};

export function Icon({ name, size = 15, className = '' }: IconProps & { name: keyof typeof ICONS | string }) {
  const LucideComp = ICONS[name];
  if (!LucideComp) return null;
  return <LucideComp className={`icon ${className}`} width={size} height={size} strokeWidth={1.7} />;
}

export function Chevron({ open, size = 13 }: { open: boolean; size?: number }) {
  return <Icon name="chevron-right" size={size} className={`chevron ${open ? 'chevron-open' : ''}`} />;
}
